/* ============================================================
   ATELIER HEADER SYSTEM - behaviour, ported from
   _bsd-home-v5-atelier-harness.html (approved 2026-06-12).
   Self-contained: no dependence on main.js / global.js.
   M1: sticky offset, compact-on-scroll, nav ink bar, search fallback.
   M2: mega panels (data + show/hide + crossfade preview + strips +
       finish tooltip + #mega-<key> deep-link).
   Mega data is hardcoded (Phase A, approved) - same taxonomy as the
   store's real collections. Phase B may move it to atelier-* menus.
   ============================================================ */
(function () {
  'use strict';

  /* ---- product-card touch "hover": JS-driven so it clears on lift ----
     iOS keeps the native :hover STUCK after a touch (the pointer-events trick didn't release
     it), and we gate :hover to pointer devices in CSS. On touch we instead drive a `.is-press`
     class: add it to the card under the finger on touchstart and as the finger drags across
     cards (elementFromPoint), and REMOVE it on lift/cancel. So the lift still plays while you
     drag through cards but vanishes the moment you let go. We never touch pointer-events, so a
     tap's click/navigation is unaffected. Runs before the header bail-out so it works on every
     page (cards aren't header-dependent). */
  if ('ontouchstart' in window) {
    var pcCur = null, pcAF = 0;
    /* stand down while the finish-bloom gesture owns the touch (atelier-finish-bloom.js
       adds .fb-on to <html>) - otherwise the press-lift fights the bloom's focal panel. */
    var fbOn = function () { return document.documentElement.classList.contains('fb-on'); };
    var pcSet = function (card) {
      if (fbOn()) card = null;
      if (card === pcCur) return;
      if (pcCur) pcCur.classList.remove('is-press');
      pcCur = card;
      if (pcCur) pcCur.classList.add('is-press');
    };
    document.addEventListener('touchstart', function (e) {
      pcSet(e.target && e.target.closest ? e.target.closest('.pc') : null);
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      var tp = e.touches && e.touches[0]; if (!tp) return;
      var x = tp.clientX, y = tp.clientY;
      if (pcAF) return;
      pcAF = requestAnimationFrame(function () {
        pcAF = 0;
        var el = document.elementFromPoint(x, y);
        pcSet(el && el.closest ? el.closest('.pc') : null);
      });
    }, { passive: true });
    var pcEnd = function () { if (pcAF) { cancelAnimationFrame(pcAF); pcAF = 0; } pcSet(null); };
    document.addEventListener('touchend', pcEnd, { passive: true });
    document.addEventListener('touchcancel', pcEnd, { passive: true });
  }

  var sect = document.querySelector('.section-atelier-header');
  if (!sect) return;
  var hdr = sect.querySelector('.at-hdr');
  var topBar = sect.querySelector('.at-top');

  var CDN = 'https://cdn.shopify.com/s/files/1/0701/6261/2373/files/';
  function $(s, c) { return (c || sect).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || sect).querySelectorAll(s)); }
  function aud(n) { return '$' + n.toLocaleString('en-AU'); }
  function pct(p, c) { return c > p ? Math.round((1 - p / c) * 100) : 0; }

  /* ---- sticky offset: the announcement strip scrolls away, the
     glass header pins. The section wrapper is sticky with a negative
     top equal to the strip's height (measured, so wrapping-safe). */
  var svgEl = sect.querySelector('.at-logo-svg');
  /* --bath-shift: how far to slide ONLY the bath mark from its spot in the lockup to
     the header centre when the header collapses on mobile (the wordmark stays put and
     wipes). The bath now lives in its OWN <svg> element (.at-lk-bath) which we translate
     wholesale, so the shift is a plain px LENGTH (CSS pixels) - no transform-box needed
     and identical on every browser. (A px translate on a <g> would be SVG user-units and
     overshoot on iOS, which is why the old fill-box % existed; an element px translate
     does not have that problem.) */
  function setLogoSwoop() {
    if (!svgEl || window.innerWidth >= 768) { sect.style.removeProperty('--bath-shift'); return; }
    var bathG = svgEl.querySelector('.bath');
    var r = svgEl.getBoundingClientRect();
    if (!bathG || !r.width) return;
    var bb; try { bb = bathG.getBBox(); } catch (e) { return; }
    if (!bb || !bb.width) return;
    var scale = r.width / 1092.7;                         /* screen px per SVG user unit */
    var bathCentre = r.left + (bb.x + bb.width / 2) * scale;
    var deltaPx = window.innerWidth / 2 - bathCentre;     /* CSS px to move the bath right */
    sect.style.setProperty('--bath-shift', deltaPx.toFixed(1) + 'px');
  }
  function setTopOffset() {
    sect.style.setProperty('--at-topbar-h', (topBar ? topBar.offsetHeight : 0) + 'px');
    /* native anchor jumps land below the pinned header */
    document.documentElement.style.scrollPaddingTop = hdr.offsetHeight + 'px';
    setLogoSwoop();
  }
  setTopOffset();
  window.addEventListener('resize', setTopOffset);
  window.addEventListener('load', setTopOffset);

  /* ---- compact-on-scroll (nothing hides - everything tightens).
     Hysteresis: compacting changes the header height (~28px), and the
     browser's scroll anchoring then shifts scrollY by the same amount -
     a single threshold oscillates (grow/shrink flicker near the top).
     The dead zone between the two thresholds is wider than the
     anchoring jump, so the loop can't close. */
  function onScroll() {
    var y = window.scrollY;
    /* mobile collapses far more header height (search row + logo morph), so widen
       the dead zone there to clear the scroll-anchor jump and avoid stick/unstick
       flicker near the threshold. */
    var on = window.innerWidth < 768 ? 110 : 64;
    if (y > on) hdr.classList.add('is-stuck');
    else if (y < 8) hdr.classList.remove('is-stuck');
    /* between the two thresholds: keep whichever state we're in (hysteresis) */
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- sliding red ink bar under the category nav */
  var navWrap = $('.at-nav .at-wrap');
  var navInk = $('.at-nav-ink');
  function inkTo(it) {
    navInk.style.width = Math.max(18, it.offsetWidth - 22) + 'px';
    navInk.style.transform = 'translateX(' + (it.offsetLeft + 11) + 'px)';
    navInk.style.opacity = 1;
  }
  if (navWrap && navInk) {
    navWrap.addEventListener('mouseover', function (e) {
      var it = e.target.closest('.at-nv');
      if (it) inkTo(it);
    });
    navWrap.addEventListener('mouseleave', function () {
      var open = navWrap.querySelector('.at-nv.is-open');
      if (open) inkTo(open);
      else navInk.style.opacity = 0;
    });
    /* arrow keys across the nav for keyboard users (skip any hidden buttons) */
    navWrap.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var items = $$('.at-nv:not(.at-nv-hide)', navWrap);
      var idx = items.indexOf(document.activeElement);
      if (idx < 0) return;
      e.preventDefault();
      items[(idx + (e.key === 'ArrowRight' ? 1 : -1) + items.length) % items.length].focus();
    });
  }

  /* ---- priority nav: as the bar narrows, hide ONLY the right-hand utility
     links when they would actually overflow - Clearance, then Packages, then
     Instant Ship, then All categories last. The eight category buttons are
     NEVER hidden. Fit is measured by summing the visible buttons' real widths,
     NOT scrollWidth (the margin-left:auto on .at-nv--right inflates scrollWidth
     and would make it hide buttons that actually fit). */
  if (navWrap) {
    var navAll = $('#atNavAllCats');
    var navUtils = [], navPastAll = false;
    $$('.at-nv', navWrap).forEach(function (it) {
      if (it === navAll) { navPastAll = true; return; }
      if (navPastAll) navUtils.push(it); /* Instant Ship, Packages, Clearance */
    });
    /* hide order: promo links right-to-left, then All categories last */
    var navHideSeq = navUtils.slice().reverse();
    if (navAll) navHideSeq.push(navAll);
    var fitNav = function () {
      if (!navWrap.clientWidth) return; /* nav hidden (<=767px) - leave as-is */
      navHideSeq.forEach(function (it) { it.classList.remove('at-nv-hide'); });
      for (var i = 0; i < navHideSeq.length; i++) {
        /* Neutralise the .at-nv--right auto margin while measuring so scrollWidth
           reflects the REAL packed content width (the auto margin otherwise
           inflates it and reports phantom overflow). >6px slop absorbs sub-pixel
           rounding, so a button that basically fits is never hidden. */
        navWrap.classList.add('at-nav-measuring');
        var overflowing = navWrap.scrollWidth - navWrap.clientWidth > 6;
        navWrap.classList.remove('at-nav-measuring');
        if (!overflowing) break;
        navHideSeq[i].classList.add('at-nv-hide');
      }
    };
    var navRaf;
    var scheduleFit = function () {
      cancelAnimationFrame(navRaf);
      navRaf = requestAnimationFrame(fitNav);
    };
    if ('ResizeObserver' in window) new ResizeObserver(scheduleFit).observe(navWrap);
    else window.addEventListener('resize', scheduleFit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
    fitNav();
  }

  /* ---- search input: the live palette module (below) owns all key
     handling. Deliberately NOT a form[action="/search"], so the stock
     Algolia autocomplete never binds to it. */
  var spInput = $('#atSearchInput');
  var spalHide = function () {}; /* reassigned by the palette module */
  /* THE HEADER'S HANDLE (header port 2026-10-08). On-demand header files load
     through here, each URL once however many callers ask (the search panel and
     the menu panels both need atelier-header-data.js). Stylesheets go in
     straight AFTER atelier-header.css - it is a section stylesheet, i.e. in
     <body>, so one appended to <head> would come first and lose every
     equal-specificity rule to it. */
  var ATHeader = window.ATHeader = window.ATHeader || {};
  (function () {
    var done = {};
    function after(el) {
      var refs = document.querySelectorAll('link[rel="stylesheet"][href*="atelier-header.css"]');
      var ref = refs[refs.length - 1];
      if (ref && ref.parentNode) ref.parentNode.insertBefore(el, ref.nextSibling);
      else document.head.appendChild(el);
    }
    ATHeader.script = function (src) {
      if (!src) return Promise.resolve();
      return done[src] || (done[src] = new Promise(function (res) {
        var el = document.createElement('script');
        el.src = src; el.async = false;
        el.onload = el.onerror = function () { res(); };
        document.body.appendChild(el);
      }));
    };
    ATHeader.css = function (href) {
      if (!href) return Promise.resolve();
      return done[href] || (done[href] = new Promise(function (res) {
        var el = document.createElement('link');
        el.rel = 'stylesheet'; el.href = href;
        el.onload = el.onerror = function () { res(); };
        after(el);
      }));
    };
    /* bytes only, never on a saver / 2G connection (the warm-up's rule) */
    var fetched = {};   /* search + panels both prefetch atelier-header-data.js */
    ATHeader.prefetch = function (href) {
      var c = navigator.connection;
      if (!href || done[href] || fetched[href] || (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')))) return;
      fetched[href] = 1;
      var el = document.createElement('link');
      el.rel = 'prefetch'; el.href = href;
      document.head.appendChild(el);
    };
    /* THE PANELS BUNDLE (Colours, Brands, Filters in the menus, the sidebar).
       Loads once: its stylesheet + both data files first (the modules read
       them at start-up), then the script. whenPanels(fn) runs fn as soon as it
       has run - or after 0.8 s regardless, so a slow or failed download falls
       back to the theme's own panel instead of to nothing; after that one
       give-up nothing waits again. */
    ATHeader.panels = function () {
      var L = window.ATLazy || {};
      if (!L.panels) return Promise.resolve();
      return ATHeader._panelsP || (ATHeader._panelsP =
        Promise.all([ATHeader.css(L.panelsCss), ATHeader.script(L.coloursData), ATHeader.script(L.data)])
          .then(function () { return ATHeader.script(L.panels); }));
    };
    /* LIVE CATALOGUE NUMBERS (2026-10-08). The panel data bakes curation AND
       numbers; the numbers drift weekly (measured: 93 counts + 3 dead filter
       values after six weeks). sections/atelier-nav-live.liquid answers, via
       the Section Rendering API, with every collection count the panels show
       (one request, on "/") and each drawer category's own storefront filters
       (one request per category - Shopify only exposes a collection's filters
       on its own URL). ~1-2 KB each, Shopify-side 0.3-0.5 s, run in parallel,
       only on header intent, cached 30 min across pages and tabs. The bundle
       applies them to its data before rendering (ATHeader.applyLive). Any
       failure leaves the baked numbers, never an error. */
    var LIVE_KEY = 'at_nav_live_v1', LIVE_TTL = 30 * 60 * 1000;
    function liveSection(url) {
      return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=atelier-nav-live', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          var m = /<script type="application\/json" id="atNavLive">([\s\S]*?)<\/script>/.exec(t);
          return m ? JSON.parse(m[1]) : null;
        })
        .catch(function () { return null; });
    }
    ATHeader.live = function () {
      if (ATHeader._liveP) return ATHeader._liveP;
      var L = window.ATLazy || {}, cached = null;
      try { cached = JSON.parse(localStorage.getItem(LIVE_KEY) || 'null'); } catch (e) { cached = null; }
      if (cached && cached.ts && Date.now() - cached.ts < LIVE_TTL) {
        window.ATNavLive = cached;
        ATHeader.liveReady = true;
        if (ATHeader.applyLive) ATHeader.applyLive(cached);
        return (ATHeader._liveP = Promise.resolve(cached));
      }
      if (!L.coloursData || !window.fetch) { ATHeader.liveReady = true; return (ATHeader._liveP = Promise.resolve(null)); }
      return (ATHeader._liveP = ATHeader.script(L.coloursData).then(function () {
        var F = window.DBFACETS || {}, hs = [];
        Object.keys(F).forEach(function (c) { var h = F[c] && F[c].handle; if (h && hs.indexOf(h) < 0) hs.push(h); });
        return Promise.all([liveSection(L.root || '/')].concat(hs.map(function (h) { return liveSection('/collections/' + h); })));
      }).then(function (res) {
        var out = { ts: Date.now(), counts: (res[0] && res[0].counts) || null, facets: {} };
        res.slice(1).forEach(function (r) { if (r && r.h && r.f) out.facets[r.h] = { total: r.total, f: r.f }; });
        if (out.counts || Object.keys(out.facets).length) {
          window.ATNavLive = out;
          try { localStorage.setItem(LIVE_KEY, JSON.stringify(out)); } catch (e) { /* storage full / blocked */ }
          if (ATHeader.applyLive) ATHeader.applyLive(out);
        }
        ATHeader.liveReady = true;
        return out;
      }, function () { ATHeader.liveReady = true; return null; }));
    };
    ATHeader.waitPanels = function () {
      return !(ATHeader.panelsReady && ATHeader.liveReady) && !ATHeader.panelsGaveUp && !!(window.ATLazy && window.ATLazy.panels);
    };
    ATHeader.whenPanels = function (fn) {
      var done = false;
      function go() {
        if (done) return;
        done = true;
        if (!(ATHeader.panelsReady && ATHeader.liveReady)) ATHeader.panelsGaveUp = true;
        fn();
      }
      Promise.all([ATHeader.panels(), ATHeader.live()]).then(go, go);
      setTimeout(go, 800);
    };
    ATHeader.idle = function (fn) {
      var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(fn, { timeout: 4000 }); };
      if (document.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
    };
  })();
  /* "/" focuses search from anywhere */
  window.addEventListener('keydown', function (e) {
    if (e.key === '/' && spInput && !/input|textarea|select/i.test(document.activeElement.tagName)) {
      e.preventDefault();
      spInput.focus();
    }
  });

  /* ============================ MEGA MENU ============================
     Link entries: [label, path, previewImage?, fitFlag?] - hovering a
     link with an image crossfades the preview window to it. */
  var MEGA = window.NAV2.mega;
  /* Ovia promo flags (v5: chips were trialled in panels and reverted -
     full text lists read better) */
  /* v2 nav: promo flags live in the NAV2 data (assets/atelier-nav-data.js) */

  /* the 13 colour collections: [name, path, css-gradient swatch] */
  /* [label, collection, finish-FAMILY slug]. The slug picks a .at-fsw--<family> gradient
     class (atelier-header.css), which MIRRORS the canonical site-wide .ac-sw--<family>
     set - so these swatches match the rest of the site and can't drift. See the family
     block in atelier-header.css + [[finish-swatch-family-matching]]. */
  /* the two nickels share one collection, pre-filtered by their own colour
     metaobject (warm/cool split applied to the data 2026-07-02) */
  var NICKEL_F = '/collections/brushed-nickel-tapware?filter.p.m.custom.colours_metaobjects=gid%3A%2F%2Fshopify%2FMetaobject%2F';
  var FINISHES = window.NAV2.finishes;

  var mega = $('#atMega'), megaScrim = document.getElementById('atMegaScrim');
  var mgImgA = $('#atMgImgA'), mgImgB = $('#atMgImgB');
  var mgTimer = null, mgKey = null, mgFlip = false, mgCur = '';

  function mgPreview(src, fit) {
    if (src === mgCur) return;
    mgCur = src;
    var back = mgFlip ? mgImgA : mgImgB, front = mgFlip ? mgImgB : mgImgA;
    back.src = src;
    back.classList.toggle('fit', !!fit);
    requestAnimationFrame(function () { back.classList.add('on'); front.classList.remove('on'); });
    mgFlip = !mgFlip;
  }
  var mgPend = null;
  function mgShow(key, it) {
    var d = MEGA[key];
    if (!d) return;
    /* the redesigned panels live in the on-demand bundle: the first open
       waits for it (see ATHeader.whenPanels) so it is never the old design */
    if (d.ptype && ATHeader.waitPanels()) {
      var tok = mgPend = {};
      ATHeader.whenPanels(function () { if (mgPend === tok) { mgPend = null; mgShow(key, it); } });
      return;
    }
    /* v2 nav: custom panel types (rail / std / colours / brands) render into
       #atMgCustom via the panels module at the end of this file */
    mega.classList.toggle('at-mega--custom', !!d.ptype);
    if (d.ptype) {
      spalHide();
      if (mgKey !== key) {
        mgKey = key;
        var cEl = document.getElementById('atMgCustom');
        if (cEl && window.__ATHRender) {
          cEl.innerHTML = window.__ATHRender(key, d);
          if (window.__ATHInit) window.__ATHInit(key, d, cEl);
        }
      }
      mega.classList.add('is-open');
      megaScrim.classList.add('on');
      mega.setAttribute('aria-hidden', 'false');
      $$('.at-nv').forEach(function (n) { n.classList.toggle('is-open', n === it); });
      inkTo(it);
      return;
    }
    spalHide();
    if (mgKey !== key) {
      mgKey = key;
      var i = 0;
      $('#atMgLinks').innerHTML = d.groups.map(function (g) {
        return '<div class="at-mg-g"><h5>' + g.h + '</h5><ul' + (g.links.length < 5 ? ' class="one"' : '') + '>' +
          g.links.map(function (l) {
            return '<li style="--i:' + (i++) + '"><a class="at-mg-l" href="' + l[1] + '"' +
              (l[2] ? ' data-img="' + l[2] + '" data-fit="' + (l[3] ? 1 : 0) + '"' : '') + '>' + l[0] + '</a></li>';
          }).join('') + '</ul></div>';
      }).join('');
      /* the red Ovia promo row (#atMgPromo) was REMOVED here (Chris 2026-07-13);
         the promo flags in NAV2 data are inert now */
      var f = d.feat, FE = $('#atMgFeat');
      if (f.type === 'prod') {
        var off = pct(f.p, f.c);
        FE.innerHTML = '<span class="at-mg-ft">Top pick</span>' +
          '<a class="at-mgp" href="' + f.h + '">' +
          '<span class="at-mgp-im">' + (off ? '<span class="at-mgp-chip">−' + off + '%</span>' : '') + '<img src="' + CDN + f.i + '" alt="' + f.t + '" loading="lazy"></span>' +
          '<span class="at-mgp-bd"><b>' + f.t + '</b><span class="at-mgp-pr"><span class="at-now">' + aud(f.p) + '</span><span class="at-was">' + aud(f.c) + '</span></span><span class="at-mgp-go">Shop now →</span></span>' +
          '</a>';
      } else {
        FE.innerHTML = '<span class="at-mg-ft">' + f.k + '</span>' +
          '<a class="at-mg-tile" href="' + f.h + '"><img src="' + CDN + f.i + '" alt="" loading="lazy">' +
          '<span>' + (f.tag ? '<i>' + f.tag + '</i>' : '') + '<b>' + f.t + '</b><span class="at-go">' + f.go + '</span></span></a>';
      }
      var S = $('#atMgStrip');
      if (d.strip === 'fin') {
        S.innerHTML = '<span class="at-mg-sl">Shop by finish</span><div class="at-mg-fins">' +
          FINISHES.map(function (x, j) {
            return '<a class="at-mg-fin at-fsw--' + x[2] + '" href="' + x[1] + '" aria-label="' + x[0] + '"><i></i></a>';
          }).join('') +
          '</div><a class="at-mg-allcat" href="/pages/colours">All colours →</a>';
      } else {
        S.innerHTML = '<span class="at-mg-sl">Quick links</span><div class="at-mg-qk">' +
          '<a href="/collections/instant-ship">Instant Ship</a>' +
          '<a href="/collections/bathroom-packages">Shop Packages</a>' +
          '<a class="hot" href="/collections/clearance">Clearance</a></div>' +
          '<a class="at-mg-allcat" href="' + d.all + '">View all ' + d.t + ' →</a>';
      }
      $('#atMgView').href = d.all;
      $('#atMgCapT').textContent = 'Explore ' + d.t;
      mgPreview(CDN + d.img, false);
      [$('#atMgView'), FE].forEach(function (el) {
        el.style.animation = 'none';
        void el.offsetHeight;
        el.style.animation = '';
      });
    }
    mega.classList.add('is-open');
    megaScrim.classList.add('on');
    mega.setAttribute('aria-hidden', 'false');
    $$('.at-nv').forEach(function (n) { n.classList.toggle('is-open', n === it); });
    inkTo(it);
  }
  ATHeader.mgHide = function () { mgHide(); };
  function mgHide() {
    mgPend = null;   /* a panel still waiting for the bundle is not wanted any more */
    mega.classList.remove('is-open');
    megaScrim.classList.remove('on');
    mega.setAttribute('aria-hidden', 'true');
    mgKey = null;
    $$('.at-nv').forEach(function (n) { n.classList.remove('is-open'); });
    navInk.style.opacity = 0;
  }
  $$('.at-nv[data-mega]').forEach(function (it) {
    it.addEventListener('mouseenter', function () {
      if (tabsAsleep()) return;   /* crossing the tab row to the results must not open a panel */
      clearTimeout(mgTimer);
      mgTimer = setTimeout(function () { mgShow(it.dataset.mega, it); }, 110);
    });
    it.addEventListener('mouseleave', function () {
      clearTimeout(mgTimer);
      mgTimer = setTimeout(mgHide, 260);
    });
    it.addEventListener('focus', function () { mgShow(it.dataset.mega, it); });
  });
  /* TABS SLEEP WHILE SEARCH IS OPEN (approved 2026-08-28; ported from the
     _harness-palfix variant C). The search panel and the mega panels both hang
     off the header's bottom edge, so the pointer crosses the tab row on its way
     to the results - a tab's 110ms hover timer used to kill the search. While
     the panel is open (desktop) a tab's hover does nothing (above) and the CSS
     dims the row (atelier-search-panel.css). A click on a sleeping tab closes
     the search and opens that tab's panel with NO navigation: that has to be
     done on MOUSEDOWN, because Chrome focuses an anchor on mousedown and the
     tab's focus handler opens a panel (which closes the search first), so by
     `click` nothing would be asleep and the link would follow. The click that
     follows is swallowed; a quick second press (double-click) too. */
  /* header INTENT runs the panels bundle (pointer, focus or touch heading for
     the nav, the burger or All categories); at idle it is only prefetched,
     so a page nobody navigates from never runs it */
  (function () {
    var L = window.ATLazy || {};
    if (!L.panels) return;
    function intent(e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.at-nv, #atBurger, #atNavAllCats, .at-mega, .at-xdrawer, .at-mdrawer')) return;
      ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) { document.removeEventListener(ev, intent, true); });
      ATHeader.panels();
      ATHeader.live();
    }
    ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, intent, { capture: true, passive: true });
    });
    /* the panels STYLESHEET is applied at idle, not on intent: inserting it
       restyles and re-lays out the whole document, and doing that inside the
       first hover measured 350-950 ms long tasks at a 4x-slowed CPU. At idle
       nobody is interacting. The Filters column's narrow-fit class goes on the
       mega panel with it (.at-mega.mrn - never <body>: a body class change is
       a whole-document restyle). The scripts stay intent-only (prefetched). */
    ATHeader.idle(function () {
      ATHeader.css(L.panelsCss).then(function () { mega.classList.add('mrn'); });
      [L.coloursData, L.data, L.panels].forEach(ATHeader.prefetch);
    });
  })();
  var spalEl = $('#atSpal'), navRow = $('.at-nav');
  function tabsAsleep() { return !!(spalEl && spalEl.classList.contains('on')) && window.innerWidth >= 768; }
  var wakeTab = null, lastWake = 0, lastWakeTab = null;
  if (navRow) {
    navRow.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;          /* middle / right click: "open in new tab" stays */
      var tab = e.target.closest && e.target.closest('.at-nv');
      if (!tab) return;
      if (!tabsAsleep()) {
        if (tab === lastWakeTab && (e.timeStamp - lastWake) < 450) { e.preventDefault(); e.stopPropagation(); wakeTab = tab; }
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      wakeTab = tab; lastWakeTab = tab; lastWake = e.timeStamp;
      spalHide();
      if (spInput) spInput.blur();
      if (tab.dataset.mega) setTimeout(function () { mgShow(tab.dataset.mega, tab); }, 0);
    }, true);
    navRow.addEventListener('click', function (e) {
      if (!wakeTab) return;
      var tab = e.target.closest && e.target.closest('.at-nv');
      if (tab === wakeTab) { e.preventDefault(); e.stopPropagation(); }
      wakeTab = null;
    }, true);
    document.addEventListener('mouseup', function () {
      if (wakeTab) setTimeout(function () { wakeTab = null; }, 0);   /* the click (if any) dispatches first */
    }, true);
  }
  mega.addEventListener('mouseenter', function () { clearTimeout(mgTimer); });
  mega.addEventListener('mouseleave', function () { mgTimer = setTimeout(mgHide, 220); });
  $('#atMgLinks').addEventListener('mouseover', function (e) {
    var a = e.target.closest('[data-img]');
    if (!a) return;
    mgPreview(CDN + a.dataset.img, a.dataset.fit === '1');
  });
  $('#atMgLinks').addEventListener('mouseleave', function () {
    var d = MEGA[mgKey];
    if (d) mgPreview(CDN + d.img, false);
  });
  megaScrim.addEventListener('click', mgHide);

  /* Esc closes everything open (mdClose/xdClose are hoisted from the
     drawer module below; palette joins in M4) */
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { mgHide(); spalHide(); mdClose(); xdClose(); }
  });

  /* ---- finish-dot tooltip: shared fixed node on <body> (scroll
     containers clip ::after pseudo-tooltips) */
  var finTip = document.createElement('div');
  finTip.className = 'at-fin-tip';
  document.body.appendChild(finTip);
  document.addEventListener('mouseover', function (e) {
    var f = e.target.closest('.at-mg-fin');
    if (!f) { finTip.classList.remove('on'); return; }
    var r = f.getBoundingClientRect();
    finTip.textContent = f.getAttribute('aria-label') || '';
    finTip.style.left = r.left + r.width / 2 + 'px';
    finTip.style.top = r.top - 30 + 'px';
    finTip.classList.add('on');
  });

  /* deep-link/debug: open a panel via #mega-<key> (e.g. #mega-tapware) */
  var mgHash = location.hash.match(/^#mega-(\w+)/);
  if (mgHash && MEGA[mgHash[1]]) {
    var hashIt = sect.querySelector('.at-nv[data-mega="' + mgHash[1] + '"]');
    if (hashIt) setTimeout(function () { mgShow(mgHash[1], hashIt); }, 400);
  }

  /* ============================ DRAWERS (M3) ============================ */
  var mdrawer = document.getElementById('atMdrawer');
  var xdrawer = document.getElementById('atXdrawer');
  var dscrim = document.getElementById('atDscrim');
  /* portal to <body>: backdrop-filter needs a clean backdrop context,
     and the drawers should not live inside the sticky header wrapper */
  [dscrim, mdrawer, xdrawer].forEach(function (el) { document.body.appendChild(el); });
  var xdLeft = document.getElementById('atXdLeft');
  var xdRight = document.getElementById('atXdRight');

  /* the page stays scrollable (scrollbar stays put - no layout jump);
     opening a drawer blurs the page roots via this body class */
  function mdOpen() {
    buildMdBody(); /* deferred build - see buildMdBody */
    mdrawer.classList.add('on');
    dscrim.classList.add('on');
    document.body.classList.add('at-drawer-open');
  }
  function mdClose() {
    mdrawer.classList.remove('on');
    if (!xdrawer.classList.contains('on')) {
      dscrim.classList.remove('on');
      document.body.classList.remove('at-drawer-open');
    }
  }

  /* mobile drawer body: Ovia promo, department accordions from MEGA,
     extra departments, finish dots, quick links */
  var MD_EXTRA = window.NAV2.mdExtra;
  var chevR = '<svg viewBox="0 0 24 24"><path d="m9 6 6 6-6 6"/></svg>';
  /* v2 drawers: CDN-resized image URL + the shared thumb-row markup
     (mirrors the panels module - floating cutout, invisible spacer when none) */
  function dwUrl(u, w) {
    if (!u) return '';
    if (!/^https?:/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120);
  }
  function dwThumb(l, px) {
    /* second img = the silhouette ground shadow (same cached URL; styled by
       the approved micro-interactions block in atelier-header.css; hidden
       in the touch-first mobile drawer) */
    /* loading="lazy" is LOAD-BEARING (warm-up v2, 2026-07-17): the mobile
       drawer body is built at init on every page, and eager imgs here fetched
       ~92 cutouts per cold load with the drawer closed. Lazy imgs in the
       hidden drawer stay unfetched; the burger-intent warm-up (width 140,
       matching dwUrl's default) has them cached before they're seen. */
    var u = dwUrl(l.img, px || 140);
    return l.cut
      ? '<span class="at-th at-th--cut"><img src="' + u + '" alt="" loading="lazy"><img class="at-th-sh" src="' + u + '" alt="" loading="lazy" aria-hidden="true"></span>'
      : '<span class="at-th at-th--cut at-th--none"></span>';
  }
  function dwCatThumb(d) {
    return '<span class="at-dw-cth">' + (d.img ? '<img src="' + dwUrl(d.img, 120) + '" alt="" loading="lazy">' : '') + '</span>'; /* 120 = the warm-up's railImg variant (was 100 - unwarmed) */
  }
  /* "Not sure what to pick?" hub row for the two drawers - same Option A card
     as the mega panes (that guideHTML lives in the panels module below). */
  var DW_GD_IC = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>';
  function gdRow(d, cls) {
    return d.hub
      ? '<a class="at-gd ' + cls + '" href="' + d.hub + '"><i class="at-gd-ic">' + DW_GD_IC + '</i>' +
        '<span class="at-gd-lb"><b>Not sure what to pick?</b><small class="at-gd-hub">' + d.guideT + '</small></span>' +
        '<span class="at-gd-btn">Start here</span></a>'
      : '';
  }
  /* Account lives here on phones (.at-act--sec, hidden from the header row below 768px).
     Wishlist is NOT here anymore - it's a primary header icon on mobile too. */
  var acctRow =
    '<div class="at-md-acct">' +
      '<a class="at-md-ai" href="/account"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5"/></svg>Account</a>' +
    '</div>';
  var mdBodyBuilt = false;
  function buildMdBody() {
    /* built on FIRST OPEN, not at init (warm-up v2, 2026-07-17): init-time
       markup made every cold load fetch ~90 drawer cutouts. loading="lazy"
       cannot save an off-canvas drawer - translateX(-100%) still sits inside
       Chromium's lazy-load margin, so the imgs fetched anyway. No markup
       until open = no fetches; the burger-intent warm-up has the shared
       width-140 variants cached before the accordion is expanded. */
    if (mdBodyBuilt) return;
    mdBodyBuilt = true;
    document.getElementById('atMdBody').innerHTML =
    acctRow +
    '<a class="at-md-promo" href="/collections/ovia">' +
      '<img src="' + CDN + 'last_frame.png" alt="" loading="lazy">' +
      '<span><small>New in</small><b>The Ovia Collection</b></span></a>' +
    '<div class="at-md-sec">Categories</div>' +
    Object.keys(window.NAV2.drawerCats).map(function (k) {
      var d = window.NAV2.drawerCats[k];
      return '<div class="at-md-cat" data-k="' + k + '">' +
        '<button class="at-md-q" type="button">' + dwCatThumb(d) + '<span class="at-dw-qt">' + d.t + '</span><svg viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg></button>' +
        '<div class="at-md-a"><div>' +
          gdRow(d, 'at-md-guide') +
          d.groups.map(function (g) {
            return g.links.map(function (l) {
              return '<a class="at-md-l at-md-l--v2" href="' + l.h + '">' + dwThumb(l) + /* 140 = the shared warmed variant (was 120) */
                '<span class="at-lb"><span class="at-lt">' + l.l + '</span>' +
                (l.n ? '<small>' + l.n.toLocaleString() + ' products</small>' : '') + '</span></a>';
            }).join('');
          }).join('') +
          '<a class="at-md-all" href="' + d.all + '">View all ' + d.t + ' →</a>' +
        '</div></div></div>';
    }).join('') +
    '<div class="at-md-sec">More categories</div>' +
    MD_EXTRA.map(function (l) { return '<a class="at-md-link" href="' + l[1] + '">' + l[0] + chevR + '</a>'; }).join('') +
    '<div class="at-md-sec">Shop by finish</div>' +
    '<div class="at-md-fins">' + FINISHES.map(function (x) {
      return '<a class="at-md-fin" href="' + x[1] + '"><span class="at-md-fsw at-fsw--' + x[2] + '"></span>' + x[0] + '</a>';
    }).join('') + '</div>' +
    '<a class="at-md-link" href="/pages/colours">Find your finish' + chevR + '</a>' +
    '<div class="at-md-sec">Quick links</div>' +
    '<a class="at-md-link" href="/collections/instant-ship">Instant Ship' + chevR + '</a>' +
    '<a class="at-md-link" href="/collections/bathroom-packages">Shop Packages' + chevR + '</a>' +
    '<a class="at-md-link hot" href="/collections/clearance">Clearance' + chevR + '</a>' +
    '<a class="at-md-link" href="/pages/brands">Shop by Brands' + chevR + '</a>' +
    '<a class="at-md-link" href="/pages/brochures">Brochures' + chevR + '</a>';
  }

  document.getElementById('atMdBody').addEventListener('click', function (e) {
    var q = e.target.closest('.at-md-q');
    if (!q) return;
    var cat = q.parentNode, was = cat.classList.contains('on');
    Array.prototype.slice.call(mdrawer.querySelectorAll('.at-md-cat.on')).forEach(function (c) { c.classList.remove('on'); });
    if (!was) cat.classList.add('on');
  });

  /* desktop side menu (two-pane) */
  var XD_EXTRA = window.NAV2.xdExtra;
  var xdLeftBuilt = false;
  function buildXdLeft() {
    /* deferred like buildMdBody - the off-canvas xdrawer's cat thumbs fetched
       at init too (same lazy-margin issue) */
    if (xdLeftBuilt) return;
    xdLeftBuilt = true;
    xdLeft.innerHTML = '<div class="at-xd-sec">Categories</div>' +
    Object.keys(window.NAV2.drawerCats).map(function (k) {
      var d = window.NAV2.drawerCats[k];
      return '<button class="at-xd-it at-xd-it--th" data-k="' + k + '" type="button">' + dwCatThumb(d) +
        '<span class="at-dw-qt">' + d.t + '</span>' + chevR + '</button>';
    }).join('') +
    '<div class="at-xd-sec">More categories</div>' +
    Object.keys(XD_EXTRA).map(function (k) {
      return '<button class="at-xd-it" data-k="' + k + '" type="button">' + XD_EXTRA[k].t + chevR + '</button>';
    }).join('') +
    '<div class="at-xd-sec">Quick links</div>' +
    '<a class="at-xd-it" href="/collections/instant-ship">Instant Ship</a>' +
    '<a class="at-xd-it" href="/collections/bathroom-packages">Shop Packages</a>' +
    '<a class="at-xd-it" href="/pages/brands">Shop by Brands</a>' +
    '<a class="at-xd-it" href="/pages/colours">Shop by Colours</a>' +
    '<a class="at-xd-it" href="/pages/brochures">Brochures</a>' +
    '<a class="at-xd-it hot" href="/collections/clearance">Clearance</a>';
  }

  function xdSelect(k) {
    var cur = xdLeft.querySelector('.at-xd-it.on[data-k]');
    if (cur && cur.dataset.k === k) return; /* same item (e.g. hovering its chevron) - don't re-render */
    Array.prototype.slice.call(xdLeft.querySelectorAll('.at-xd-it[data-k]')).forEach(function (b) {
      b.classList.toggle('on', b.dataset.k === k);
    });
    var d = window.NAV2.drawerCats[k], x = XD_EXTRA[k];
    if (d) {
      var i = 0;
      xdRight.innerHTML = '<div class="at-xd-rt"><h4>' + d.t + '</h4><a href="' + d.all + '">View all →</a></div>' +
        gdRow(d, 'at-xd-guide') +
        d.groups.map(function (g) {
          return '<div class="at-mg-g"><h5>' + g.h + '</h5><ul' + (g.links.length < 5 ? ' class="one"' : '') + '>' +
            g.links.map(function (l) {
              return '<li style="--i:' + (i++) + '"><a class="at-mg-l at-mg-l--v2" href="' + l.h + '">' + dwThumb(l) +
                '<span class="at-lb"><span class="at-lt">' + l.l + '</span>' +
                (l.n ? '<small>' + l.n.toLocaleString() + ' products</small>' : '') + '</span></a></li>';
            }).join('') + '</ul></div>';
        }).join('') +
        (d.feat && window.__ATHFeat
          ? '<div class="at-xd-feat">' + window.__ATHFeat(d.feat) + '</div>'
          : '<a class="at-xd-im" href="' + d.all + '"><img src="' + dwUrl(d.img, 640) + '" alt="" loading="lazy"><span>Explore ' + d.t + ' →</span></a>');
    } else if (x) {
      xdRight.innerHTML = '<div class="at-xd-rt"><h4>' + x.t + '</h4><a href="' + x.all + '">View all →</a></div>' +
        '<a class="at-xd-im" style="aspect-ratio:16/9;margin-top:4px" href="' + x.all + '"><img src="' + dwUrl(x.img, 640) + '" alt="" loading="lazy"><span>Browse ' + x.t + ' →</span></a>';
    }
  }
  /* the extended pane lives only while the cursor is on a department
     button or inside the pane itself; a grace period absorbs accidental
     exits before it folds back to the narrow departments rail */
  var expTimer = null;
  function xdExpand() {
    clearTimeout(expTimer);
    xdrawer.classList.add('is-exp');
  }
  function xdCollapse() {
    clearTimeout(expTimer);
    expTimer = setTimeout(function () {
      xdrawer.classList.remove('is-exp');
      Array.prototype.slice.call(xdLeft.querySelectorAll('.at-xd-it.on')).forEach(function (b) {
        b.classList.remove('on');
      });
    }, 350);
  }
  function xdHoverZone(e) {
    if (e.target.closest('.at-xd-it[data-k]') || e.target.closest('.at-xd-right')) xdExpand();
    /* bottom "Shop all categories" link is neutral: hovering it must not fold
       the expanded pane out from under the cursor */
    else if (e.target.closest('.at-xd-all')) clearTimeout(expTimer);
    /* the top bar spans the full drawer width. Split it at the departments-rail
       edge: hovering the head over the EXTENDED pane keeps it open; hovering the
       head over the NON-EXTENDED (narrow) side collapses it, so reaching up to
       that side folds the pane back as expected */
    else if (e.target.closest('.at-xd-head')) {
      if (e.clientX > xdLeft.getBoundingClientRect().right) clearTimeout(expTimer);
      else xdCollapse();
    }
    else xdCollapse();
  }
  function xdOpen() {
    buildXdLeft(); /* deferred build - see buildMdBody's rationale */
    xdrawer.classList.add('on');
    dscrim.classList.add('on');
    document.body.classList.add('at-drawer-open');
  }
  function xdClose() {
    clearTimeout(expTimer);
    xdrawer.classList.remove('on', 'is-exp');
    if (!mdrawer.classList.contains('on')) {
      dscrim.classList.remove('on');
      document.body.classList.remove('at-drawer-open');
    }
  }
  xdrawer.addEventListener('mouseover', xdHoverZone);
  xdrawer.addEventListener('focusin', xdHoverZone);
  xdrawer.addEventListener('mouseleave', xdCollapse);
  document.getElementById('atMdX').addEventListener('click', mdClose);
  document.getElementById('atXdX').addEventListener('click', xdClose);
  dscrim.addEventListener('click', function () { mdClose(); xdClose(); });
  xdLeft.addEventListener('mouseover', function (e) {
    var b = e.target.closest('.at-xd-it[data-k]');
    if (b) { xdSelect(b.dataset.k); xdExpand(); }
  });
  xdLeft.addEventListener('click', function (e) {
    var b = e.target.closest('.at-xd-it[data-k]');
    if (b) { xdSelect(b.dataset.k); xdExpand(); }
  });
  /* >= 992 (desktop, mouse) gets the hover two-pane drawer; below that, all
     touch devices (incl. tablets) get the tap-accordion mobile drawer. Boundary
     matches the .at-xdrawer display:none cutoff in atelier-header.css. */
  function openMenuDrawer() {
    /* the sidebar redesign is in the on-demand bundle and restructures the
       drawer as it is built - so wait for it rather than build the old one
       and swap it in front of the shopper */
    if (ATHeader.waitPanels()) { ATHeader.whenPanels(openMenuDrawer); return; }
    if (window.innerWidth >= 992) xdOpen(); else mdOpen();
  }
  document.getElementById('atBurger').addEventListener('click', openMenuDrawer);
  var allCats = document.getElementById('atNavAllCats');
  if (allCats) allCats.addEventListener('click', function (e) { e.preventDefault(); openMenuDrawer(); });

  /* debug deep-links: #drawer / #xdrawer */
  if (location.hash === '#drawer') setTimeout(mdOpen, 400);
  if (location.hash.indexOf('#xdrawer') === 0) setTimeout(function () {
    xdOpen();
    var m = location.hash.match(/&cat=(\w+)/);
    if (m && window.NAV2.drawerCats[m[1]]) { xdSelect(m[1]); xdExpand(); }
  }, 400);

  /* ================= SEARCH PANEL - LOADED ON INTENT =================
     (header port 2026-10-08; replaces the M4 palette module that lived here)
     The panel is assets/atelier-search-panel.js + .css (~41 KB + 9 KB
     compressed, ~100 ms of start-up on a slow phone). A closed panel needs
     none of it, so nothing loads with the page. It loads, once, when:
     - the pointer ENTERS the search field area, a touch starts on it, or it
       takes focus (Tab, the "/" shortcut above) - pointerenter typically lands
       100-300 ms before the click, the same lead the nav warm-up uses;
     - the shopper RETURNS (Back) to a page with a saved search place;
     and at idle the three files are PREFETCHED (bytes only, no compile), so
     the intent load is normally a cache hit.
     The panel's boot replays a focus / typed text that happened before it
     arrived ("LOADED LATE" at the end of the panel file). Enter before it
     arrives goes straight to the search page. */
  (function () {
    var L = window.ATLazy || {};
    var wrap = $('.at-srch-wrap');
    if (!wrap || !spInput || !L.search || !L.searchCss || !L.data) return;
    spalHide = function () { if (window.ATSearch) window.ATSearch.hide(); };
    var started = false;
    function load() {
      if (started) return;
      started = true;
      wrap.removeEventListener('pointerenter', load);
      wrap.removeEventListener('touchstart', load);
      wrap.removeEventListener('focusin', load);
      /* styles first and data first: the panel paints the moment it runs */
      Promise.all([ATHeader.css(L.searchCss), ATHeader.script(L.data)])
        .then(function () { return ATHeader.script(L.search); });
    }
    wrap.addEventListener('pointerenter', load, { passive: true });
    wrap.addEventListener('touchstart', load, { passive: true });
    wrap.addEventListener('focusin', load);
    spInput.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || window.ATSearch) return;
      var q = spInput.value.trim();
      if (!q) return;
      e.preventDefault();
      window.location.href = (L.searchUrl || '/search') + '?q=' + encodeURIComponent(q);
    });
    /* a return with a place to restore: now (the panel decides whether the
       saved place is still fresh) */
    try {
      if (sessionStorage.getItem('bsd_hs_place')) {
        var ne = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
        if ((ne && ne.type === 'back_forward') || (history.state && history.state.hs)) { load(); return; }
      }
    } catch (e) { /* storage blocked - nothing to restore */ }
    ATHeader.idle(function () {
      if (started) return;
      [L.searchCss, L.data, L.search].forEach(ATHeader.prefetch);
    });
  })();

})();

/* ============================================================
   HOMEPAGE LOGO ENTRANCE - "Tile Lay In".
   The hexes rest hidden under .at-logo--entrance (server-rendered
   on the homepage only). We compute a per-tile L->R stagger (by
   SVG x-centroid) and then add .is-playing to start it -- but we
   WAIT until the page has settled past the initial load storm
   (fonts ready + main thread idle) so the sweep doesn't compete
   with fonts/scripts/layout and stays smooth. Capped so the logo
   is never held hidden for long; fully guarded so it can never
   stay hidden. Locked design: .en-tile in
   _bsd-atelier-loader-concepts.html.
   ============================================================ */
(function () {
  'use strict';
  function revealStatic(svg) {                  // last-resort: show the logo, no animation
    try {
      Array.prototype.forEach.call(svg.querySelectorAll('.bath > *'), function (t) {
        t.style.opacity = '1'; t.style.transform = 'none';
      });
      var w = svg.querySelector('.wm');
      if (w) { w.style.opacity = '1'; w.style.clipPath = 'none'; }
    } catch (e) {}
  }
  try {
    // --- decide whether to welcome: play on a fresh visit (first page this tab
    // session) or a reload; stay silent when navigating back to home mid-browse.
    // Read the session flag BEFORE setting it; set it on EVERY page (incl. non-home)
    // so an in-session return to the homepage is recognised. If storage is blocked,
    // seen stays falsy and we default to welcoming.
    var SEEN_KEY = 'bsd_atelier_seen', seen;
    try { seen = sessionStorage.getItem(SEEN_KEY); sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    var isReload = false;
    try {
      var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (navEntry) isReload = navEntry.type === 'reload';
      else if (performance.navigation) isReload = performance.navigation.type === 1;
    } catch (e) {}

    var link = document.querySelector('.at-logo--entrance');
    if (!link) return;                          // not the homepage (flag already set above)
    var svg = link.querySelector('.at-logo-svg');
    if (!svg) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // CSS shows it static
    var tiles = Array.prototype.slice.call(svg.querySelectorAll('.bath > *'));
    if (!tiles.length) { revealStatic(svg); return; }
    if (!(isReload || !seen)) { revealStatic(svg); return; } // in-session return to home -> no re-welcome
    var wm = svg.querySelector('.wm');
    var SPAN = 0.55;                            // locked stagger span (s), L->R

    function play() {
      try {
        var cx = tiles.map(function (t) { var b = t.getBBox(); return b.x + b.width / 2; });
        var min = Math.min.apply(null, cx), max = Math.max.apply(null, cx), range = (max - min) || 1;
        tiles.forEach(function (t, i) {
          t.style.animationDelay = (((cx[i] - min) / range) * SPAN).toFixed(3) + 's';
          t.style.willChange = 'transform, opacity';
        });
        if (wm) wm.style.willChange = 'clip-path';
        link.classList.add('is-playing');       // delays already set -> clean staggered start
        setTimeout(function () {                 // drop compositor hints once it has finished (~1.6s)
          tiles.forEach(function (t) { t.style.willChange = 'auto'; });
          /* clear the inline hint (don't force 'auto') so the CSS will-change for
             the scroll-morph wipe takes over on the wordmark */
          if (wm) wm.style.willChange = '';
          /* release the entrance class so its animation-fill stops pinning the
             wordmark's clip-path - frees it for the mobile scroll-morph wipe */
          link.classList.remove('at-logo--entrance');
        }, 2200);
      } catch (e) { revealStatic(svg); }
    }

    // Start once the page is past the load storm: fonts settled, then a frame
    // when the main thread is idle. Hard-capped so we never stall the welcome.
    var fired = false;
    function trigger() { if (fired) return; fired = true; requestAnimationFrame(play); }
    var afterFonts = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(trigger, { timeout: 700 });
      else setTimeout(trigger, 80);
    };
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(afterFonts, afterFonts);
    } else {
      afterFonts();
    }
    setTimeout(trigger, 1500);                   // cap: play even if the idle signal never comes
  } catch (e) {
    var l = document.querySelector('.at-logo--entrance');
    if (l) { var s = l.querySelector('.at-logo-svg'); if (s) revealStatic(s); }
  }
})();


/* ============================================================
   ATELIER NAV V2 - custom mega-panel renderers (ported 2026-07-02).
   Pure HTML-string renderers + delegated interactions; no access
   to the header IIFE closure needed. The fork calls
   window.__ATHRender(key, d) and injects into #atMgCustom.
   Panel types: rail (Bathroom) / colours / brands.
   At port time this file merges into atelier-header.js and the
   styles in _harness-nav-v2.css merge into atelier-header.css.
   ============================================================ */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function thumbUrl(u, w) {
    if (!u) return '';
    if (!/^https?:/.test(u)) return u; /* local cutout file - no CDN params */
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 120);
  }
  var chev = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  /* ---------------- BATHROOM: two-level rail + pane ---------------- */
  /* the rail item is a LINK to the department's parent collection (Chris
     2026-08-25) - it always looked clickable and did nothing. Hovering still
     swaps the pane; the click handler below covers the touch case. Falls back
     to the hub for a cat with no parent collection (Wastes & Traps). */
  function railItem(c, on) {
    return '<a class="at-rl-it' + (on ? ' on' : '') + '" data-ck="' + c.k + '" href="' + (c.coll || c.hub) + '">' +
      '<span class="at-rl-th">' + (c.railImg ? '<img src="' + thumbUrl(c.railImg, 120) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="at-rl-tx"><b>' + esc(c.t) + '</b><small>' + c.n.toLocaleString() + ' products</small></span>' +
      chev + '</a>';
  }
  function linkHTML(l, i) {
    /* cutout thumbs float free (no box); links without a cutout keep an
       invisible spacer so labels stay column-aligned. Eager + CDN-resized:
       the intent warm-up below has usually cached these before a pane opens. */
    var u = thumbUrl(l.img, 140);
    var th = l.cut
      ? '<span class="at-th at-th--cut"><img src="' + u + '" alt=""><img class="at-th-sh" src="' + u + '" alt="" aria-hidden="true"></span>'
      : (l.img
        ? '<span class="at-th"><img src="' + u + '" alt=""></span>'
        : '<span class="at-th at-th--cut at-th--none"></span>');
    return '<li style="--i:' + i + '"><a class="at-mg-l at-mg-l--v2" href="' + l.h + '">' + th +
      '<span class="at-lb"><span class="at-lt">' + esc(l.l) + '</span>' +
      (l.n ? '<small>' + l.n.toLocaleString() + ' products</small>' : '') +
      '</span></a></li>';
  }
  /* feature slot (right column): 'prod' = Top-pick product card, 'tile' =
     editorial image tile - both reuse the production .at-mgp / .at-mg-tile look */
  var CDNF = 'https://cdn.shopify.com/s/files/1/0701/6261/2373/files/';
  function featHTML(f) {
    if (!f) return '';
    if (f.type === 'prod') {
      /* LIVE product wins over the baked values. Title, price, compare-at and
         image all drifted while they were hard-coded in the nav data - six of
         seven cards were advertising a price BELOW the real one, and the
         Showers card still carried the pre-rename product's image. ATFeat is
         emitted by snippets/atelier-nav-feat.liquid from all_products; the
         baked values remain as a fallback if a product goes unpublished. */
      var live = (window.ATFeat || {})[f.ph] || null;
      var ft = live ? live.t : f.t;
      var fh = live && live.u ? live.u : f.h;
      var fp = live ? live.p : f.p;
      var fc = live ? live.c : f.c;
      var fi = live && live.i ? live.i : thumbUrl(CDNF + f.i, 480);
      var off = (fc && fp && fc > fp) ? Math.round((1 - fp / fc) * 100) : 0;
      return '<span class="at-mg-ft">Top pick</span>' +
        '<a class="at-mgp" href="' + fh + '">' +
        '<span class="at-mgp-im">' + (off ? '<span class="at-mgp-chip">&minus;' + off + '%</span>' : '') +
        '<img src="' + fi + '" alt="' + esc(ft) + '" loading="lazy"></span>' +
        '<span class="at-mgp-bd"><b>' + esc(ft) + '</b>' +
        '<span class="at-mgp-pr"><span class="at-now">$' + fp.toLocaleString() + '</span>' +
        (off ? '<span class="at-was">$' + fc.toLocaleString() + '</span>' : '') + '</span>' +
        '<span class="at-mgp-go">Shop now &rarr;</span></span></a>';
    }
    return '<span class="at-mg-ft">' + esc(f.k) + '</span>' +
      '<a class="at-mg-tile" href="' + f.h + '"><img src="' + thumbUrl(CDNF + f.i, 640) + '" alt="" loading="lazy">' +
      '<span>' + (f.tag ? '<i>' + esc(f.tag) + '</i>' : '') + '<b>' + esc(f.t) + '</b><span class="at-go">' + esc(f.go) + '</span></span></a>';
  }
  /* "Not sure what to pick?" hub banner - Chris-approved Option A (2026-07-13,
     picked from the 4-concept sandbox review): white gallery card + hairline,
     compass on cream, solid crimson pill CTA. Renders at the TOP of every pane
     so the hub entry is the first thing seen (the head's View-all also lands
     on the hub, but its label hides the guided finder behind it). */
  var GD_IC = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>';
  function guideHTML(hub, sub) {
    return hub
      ? '<a class="at-gd" href="' + hub + '"><i class="at-gd-ic">' + GD_IC + '</i>' +
        '<span class="at-gd-lb"><b>Not sure what to pick?</b><small>' + sub + '</small></span>' +
        '<span class="at-gd-btn">Start here</span></a>'
      : '';
  }
  function paneHTML(c) {
    var i = 0;
    return '<div class="at-rl-head"><h4>' + esc(c.t) + '</h4><a class="at-rl-all" href="' + (c.coll || c.hub) + '">View all ' + esc(c.t) + ' &rarr;</a></div>' +
      guideHTML(c.hub, 'The <b class="at-gd-hub">' + esc(c.t) + ' Hub</b> compares types, finishes &amp; prices.') +
      '<div class="at-rl-cols"><div class="at-rl-groups">' +
      c.groups.map(function (g) {
        return '<div class="at-mg-g"><h5>' + esc(g.h) + '</h5><ul' + (g.links.length < 5 ? ' class="one"' : '') + '>' +
          g.links.map(function (l) { return linkHTML(l, i++); }).join('') + '</ul></div>';
      }).join('') +
      '</div>' +
      '<div class="at-rl-feat">' + featHTML(c.feat) + '</div>' +
      '</div>';
  }
  function railHTML(d) {
    return '<div class="at-wrap at-rl">' +
      '<div class="at-rl-rail" role="tablist" aria-label="Bathroom categories">' +
      d.cats.map(function (c, i) { return railItem(c, i === 0); }).join('') +
      '</div>' +
      '<div class="at-rl-pane" id="atRlPane" data-ck="' + d.cats[0].k + '">' + paneHTML(d.cats[0]) + '</div>' +
      '</div>';
  }
  /* sliding red ink accent: one bar per rail that glides to the selected
     category (approved micro-interaction; selection follows hover here) */
  function railInk(rail, btn) {
    if (!rail || !btn) return;
    var ink = rail.querySelector('.at-rl-ink');
    if (!ink) {
      ink = document.createElement('span');
      ink.className = 'at-rl-ink';
      rail.appendChild(ink);
    }
    ink.style.transform = 'translateY(' + (btn.offsetTop + (btn.offsetHeight - 26) / 2) + 'px)';
    ink.classList.add('on');
  }
  function railSelect(btn) {
    var pane = document.getElementById('atRlPane');
    if (!pane || pane.dataset.ck === btn.dataset.ck) return;
    var d = window.NAV2.mega.bathroom;
    var cat = null;
    for (var i = 0; i < d.cats.length; i++) if (d.cats[i].k === btn.dataset.ck) cat = d.cats[i];
    if (!cat) return;
    var rail = btn.parentNode;
    Array.prototype.slice.call(rail.querySelectorAll('.at-rl-it')).forEach(function (b) {
      b.classList.toggle('on', b === btn);
    });
    railInk(rail, btn);
    pane.dataset.ck = cat.k;
    pane.innerHTML = paneHTML(cat);
  }

  /* ---------------- KITCHEN / LAUNDRY: standard layout, dict links w/ thumbs.
     Mirrors the production .at-mg-grid (links | preview | feature) + a quick
     strip row, but renders the v2 dict format so links carry thumbnails. */
  function stdHTML(d) {
    var i = 0;
    /* dense panels (10+ links) earn the short-viewport compaction (hero
       dropped, 3 columns); small panels like Laundry keep the full layout */
    var total = 0;
    d.groups.forEach(function (g) { total += g.links.length; });
    return '<div class="at-wrap at-v2-std' + (total >= 10 ? ' at-v2-std--dense' : '') + '">' +
      (d.hub ? guideHTML(d.hub, 'The <b class="at-gd-hub">' + esc(d.guideT) + '</b> compares types, finishes &amp; prices.') : '') +
      '<div class="at-v2-links">' +
      d.groups.map(function (g) {
        return '<div class="at-mg-g"><h5>' + esc(g.h) + '</h5><ul' + (g.links.length < 5 ? ' class="one"' : '') + '>' +
          g.links.map(function (l) { return linkHTML(l, i++); }).join('') + '</ul></div>';
      }).join('') +
      '</div>' +
      /* the Explore hero now STACKS UNDER the Top pick in the right column
         (Chris 2026-08-25) instead of taking a 340px column of its own -
         that third column forced the links to 2-up and made Tapware the
         tallest panel in the header. Same slot, shared side area. */
      '<div class="at-v2-feat">' + featHTML(d.feat) +
      '<a class="at-rl-im at-v2-view" href="' + d.all + '">' +
      '<img class="at-v2-hero" src="' + thumbUrl(d.img, 640) + '" alt="" loading="lazy">' +
      '<span>Explore ' + esc(d.t) + ' &rarr;</span></a></div>' +
      '</div>' +
      '<div class="at-v2-strip"><div class="at-wrap">' +
      (d.strip === 'fin'
        ? '<span class="at-mg-sl">Shop by finish</span><div class="at-mg-fins">' +
          /* strip uses finishStrip: the filter-rail order, culled to real
             metal finishes. Falls back to the full list if absent. */
          (window.NAV2.finishStrip || window.NAV2.finishes || []).map(function (x) {
            return '<a class="at-mg-fin at-fsw--' + x[2] + '" href="' + x[1] + '" aria-label="' + esc(x[0]) + '"><i></i></a>';
          }).join('') +
          '</div><a class="at-mg-allcat" href="/pages/colours">All colours &rarr;</a>'
        : '<span class="at-mg-sl">Quick links</span><div class="at-mg-qk">' +
          (d.quick || []).map(function (q) {
            return '<a' + (/clearance/i.test(q[0]) ? ' class="hot"' : '') + ' href="' + q[1] + '">' + esc(q[0]) + '</a>';
          }).join('') + '</div>' +
          '<a class="at-mg-allcat" href="' + d.all + '">View all ' + esc(d.t) + ' &rarr;</a>') +
      '</div></div>';
  }

  /* ---------------- COLOURS: finish tiles ---------------- */
  function coloursHTML(d) {
    return '<div class="at-wrap at-clp">' +
      '<div class="at-clp-side">' +
        '<span class="at-mg-ft">Shop by colour</span>' +
        '<h4>One finish,<br>every piece.</h4>' +
        '<p>Each collection gathers tapware, showers, wastes and accessories in a single finish - so the whole room matches.</p>' +
        '<a class="at-clp-find" href="/pages/colours">Find your finish &rarr;</a>' +
      '</div>' +
      '<div class="at-clp-grid">' +
      d.finishes.map(function (f, i) {
        return '<a class="at-clp-t" style="--i:' + i + '" href="' + f.h + '">' +
          '<i class="at-fsw--' + f.sw + '"></i><b>' + esc(f.l) + '</b>' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></a>';
      }).join('') +
      '</div></div>';
  }

  /* ---------------- BRANDS: logo tiles ---------------- */
  /* true-vector logo lookup: window.ATBrandSVG (emitted by atelier-header.liquid,
     keys = handleized brand name) - crisp at any size, preferred over the
     raster nav-data URLs */
  function brandSvg(name) {
    var m = window.ATBrandSVG || {};
    return m[(name || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-')] || '';
  }
  function brandsHTML(d) {
    var f = d.featured, fsvg = f ? brandSvg(f.name) : '';
    return '<div class="at-wrap at-brp">' +
      (f ? '<a class="at-brp-feat" href="' + f.h + '">' +
        '<span class="at-mg-ft">Featured brand</span>' +
        '<span class="at-brp-fim' + (fsvg ? ' at-brp-fim--svg' : '') + '">' +
          (fsvg ? '<img src="' + fsvg + '" alt="' + esc(f.name) + '">'
                : f.logo ? '<img src="' + thumbUrl(f.logo, 480) + '" alt="' + esc(f.name) + '">' : '') + '</span>' +
        '<p>' + esc(f.d || 'Designed. Considered. Crafted. Refined.') + '</p>' +
        '<span class="at-go">Explore ' + esc(f.name) + ' &rarr;</span></a>' : '') +
      '<div class="at-brp-main">' +
        '<div class="at-brp-grid">' +
        d.brands.map(function (b, i) {
          /* SVG wordmarks sit contained with breathing room; the raster
             brands metaobject images FILL the tile as before (see the
             brand-logo-fill convention) - caption below either way */
          var sv = brandSvg(b.name);
          var im = sv ? '<img src="' + sv + '" alt="" loading="lazy">'
                 : b.logo ? '<img src="' + thumbUrl(b.logo, 320) + '" alt="" loading="lazy">'
                 : '<b class="at-brp-nm">' + esc(b.name) + '</b>';
          return '<a class="at-brp-t" style="--i:' + i + '" href="' + b.h + '">' +
            '<span class="at-brp-im' + (sv ? ' at-brp-im--svg' : '') + '">' + im + '</span>' +
            '<span class="at-brp-cap"><b>' + (sv || b.logo ? esc(b.name) : '') + '</b><small>' + b.n.toLocaleString() + '</small></span></a>';
        }).join('') +
        '</div>' +
        '<a class="at-brp-all" href="' + d.all + '">All brands &rarr;</a>' +
      '</div></div>';
  }

  window.__ATHRender = function (key, d) {
    if (d.ptype === 'rail') return railHTML(d);
    if (d.ptype === 'std') return stdHTML(d);
    if (d.ptype === 'colours') return coloursHTML(d);
    if (d.ptype === 'brands') return brandsHTML(d);
    return '';
  };
  window.__ATHInit = function (key, d, cEl) {
    /* rail panels: position the ink on the selected category once laid out */
    if (d && d.ptype === 'rail' && cEl) {
      requestAnimationFrame(function () {
        var rail = cEl.querySelector('.at-rl-rail');
        if (rail) railInk(rail, rail.querySelector('.at-rl-it.on'));
      });
    }
  };
  window.__ATHFeat = featHTML; /* reused by the drawer right pane */

  /* rail interactions: hover or click a rail item swaps the pane; hovering a
     link with a curated preview (data-pv) swaps the pane hero image */
  document.addEventListener('mouseover', function (e) {
    var b = e.target.closest && e.target.closest('.at-rl-it');
    if (b) railSelect(b);
  });
  /* harness deep-link: #mega-bathroom&cat=<key> selects a rail category after
     the panel's own 400ms deep-link open (used for headless verification) */
  var catHash = location.hash.match(/&cat=(\w+)/);
  if (catHash) {
    setTimeout(function () {
      var b = document.querySelector('.at-rl-it[data-ck="' + catHash[1] + '"]');
      if (b) railSelect(b);
    }, 900);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.at-rl-it');
    if (!b) return;
    /* no-hover (touch) devices cannot preview a pane by hovering, so the FIRST
       tap selects the category and only a second tap on the already-selected
       item follows the link. Pointer devices navigate on the first click. */
    if (!b.classList.contains('on') && window.matchMedia &&
        window.matchMedia('(hover: none)').matches) {
      e.preventDefault();
      railSelect(b);
      return;
    }
    railSelect(b);
  });

  /* ---- panel-image warm-up v2 (2026-07-17): starts on first nav INTENT, not
     on page load. The old always-on warm-up cost every cold landing ~1MB /
     ~260 requests even when the visitor never opened the nav (measured in the
     business-case Lighthouse audit). pointerover/focusin/touchstart on the nav
     row or a drawer trigger fires 150-400ms before a pane can open, and the
     pane being approached is queued FIRST, so its images are normally cached
     by open time. Stragglers fade in via fadePending below instead of popping.
     Data-saver / 2G connections skip the warm-up entirely (pane imgs just
     load on open). Trickle pacing unchanged (6 per 120ms tick). */
  function preloadPanelImages(firstKey) {
    try {
      var nav = window.NAV2;
      if (!nav) return;
      var urls = [], seen = {};
      function add(u, w) {
        if (!u) return;
        var full = thumbUrl(u, w || 140);
        if (seen[full]) return;
        seen[full] = 1;
        urls.push(full);
      }
      /* push a URL that is ALREADY sized - running it through add() would
         append a second width param and warm a different file than the one
         the card renders */
      function addExact(u) {
        if (!u || seen[u]) return;
        seen[u] = 1;
        urls.push(u);
      }
      function feat(f) {
        if (!f) return;
        /* a Top pick card renders the LIVE product image from ATFeat, so warm
           THAT url. Warming the baked CDNF one left the card fetching its
           image cold on open - the warm-up was preloading a file the card no
           longer uses. ATFeat's url already carries width=480 from liquid. */
        if (f.type === 'prod') {
          var live = (window.ATFeat || {})[f.ph];
          if (live && live.i) { addExact(live.i); return; }
        }
        /* widths must MATCH featHTML's renders (prod card 480 / tile 640) -
           a mismatched warm width means the same file downloads twice */
        if (f.i) add(CDNF + f.i, f.type === 'prod' ? 480 : 640);
      }
      /* a category whose panel carries a Filters column never shows its
         feature image (the column takes that slot) - do not warm it */
      function hasRefine(k, std) {
        try { return !!(window.__MRHas && window.__MRHas(k, std)); } catch (e) { return false; }
      }
      function dept(k) {
        return function () {
          var d = nav.mega[k];
          if (!d) return;
          add(d.img, 640);
          if (!hasRefine(k, true)) feat(d.feat);
          d.groups.forEach(function (g) { g.links.forEach(function (l) { add(l.img); }); });
        };
      }
      var builders = {
        bathroom: function () {
          (nav.mega.bathroom.cats || []).forEach(function (c) {
            add(c.railImg, 120);
            add(c.railImg, 640);
            if (!hasRefine(c.k, false)) feat(c.feat);
            c.groups.forEach(function (g) { g.links.forEach(function (l) { add(l.img); }); });
          });
        },
        kitchen: dept('kitchen'),
        laundry: dept('laundry'),
        tapware: dept('tapware'),
        brands: function () {
          (nav.mega.brands.brands || []).forEach(function (b) {
            var sv = brandSvg(b.name);
            if (sv) { urls.push(sv); } else { add(b.logo, 320); }
          });
          if (nav.mega.brands.featured) {
            var fsv = brandSvg(nav.mega.brands.featured.name);
            if (fsv) { urls.push(fsv); } else { add(nav.mega.brands.featured.logo, 480); }
          }
        }
      };
      var order = ['bathroom', 'kitchen', 'laundry', 'tapware', 'brands'];
      if (firstKey && builders[firstKey]) builders[firstKey](); /* seen-map dedupes the ordered pass */
      order.forEach(function (k) { builders[k](); });
      var i = 0;
      (function next() {
        for (var n = 0; n < 6 && i < urls.length; n++, i++) {
          (new Image()).src = urls[i];
        }
        if (i < urls.length) setTimeout(next, 120);
      })();
    } catch (e) { /* warm-up is best-effort only */ }
  }
  var warmed = false;
  function warmOnIntent(e) {
    if (warmed) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('.at-nv, #atBurger, #atNavAllCats, .at-mega, .at-xdrawer, .at-mdrawer')) return;
    warmed = true;
    var c = navigator.connection || {};
    if (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) return;
    var nv = t.closest('.at-nv[data-mega]');
    var first = nv ? nv.dataset.mega : null;
    /* after the panels bundle: it says which categories carry a Filters
       column, whose feature image is never shown (window.__MRHas) */
    var AH = window.ATHeader;
    if (AH && AH.panels) AH.panels().then(function () { preloadPanelImages(first); });
    else preloadPanelImages(first);
  }
  ['pointerover', 'focusin', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, warmOnIntent, { capture: true, passive: true });
  });

  /* late-arrival fade: a pane/drawer img that isn't already cached when its
     markup lands gets .at-imgwait until it loads - CSS fades it in. Cached
     imgs are complete at insert time, never get the class, and render
     instantly (the no-visible-mechanism bar). Silhouette shadows (.at-th-sh)
     are excluded - their opacity belongs to the approved hover
     micro-interaction and must not gain a competing transition. */
  function fadePending(root) {
    if (!root || root.nodeType !== 1) return;
    var imgs = root.tagName === 'IMG' ? [root] : root.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (im) {
      if (im.complete) return;
      if (im.className.indexOf('at-th-sh') > -1 || im.className.indexOf('at-imgfade') > -1) return;
      im.classList.add('at-imgfade', 'at-imgwait');
      function done() { im.classList.remove('at-imgwait'); }
      im.addEventListener('load', done, { once: true });
      im.addEventListener('error', done, { once: true });
    });
  }
  ['at-mega', 'at-xdrawer', 'at-mdrawer'].forEach(function (cls) {
    var el = document.querySelector('.' + cls);
    if (!el) return;
    fadePending(el);
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        for (var n = 0; n < muts[m].addedNodes.length; n++) fadePending(muts[m].addedNodes[n]);
      }
    }).observe(el, { childList: true, subtree: true });
  });
})();
